module.exports = new __parcel__URL__("TetherLogo.6d30f474.svg").toString();